app.service('RegulationClientApiService', [
    'crudService', '$window', '$stateParams',
    function (crudService, $window, $stateParams) {
        this.contract_id = $stateParams.contrat_id || null;
        this.ALL_REQUEST_NAME = 'client.regulations.texts.all';

        if (!this.contract_id) {
            throw new Error("[ERR] RegulationClientApiService - contract id must be defined !");
        }

        this.baseUri = '/contrat_cadre/:contract_id/texts';

        this.all = function (searchParams) {
            return crudService.post(this.getUri('/'), searchParams, {cancelable: this.ALL_REQUEST_NAME});
        };

        this.get = function (regulation_id) {
            return crudService.post(this.getUri('/:regulation_id', {'regulation_id': regulation_id}));
        };

        this.exportUrl = function (data) {
            return this._setUrlParams(this.getUri('/export'), data);
        };

        this.loadSites = function () {
            return crudService.get(this.getUri().replace('texts', 'sites'));
        };

        this.cancelRequest = function (cancelable) {
            crudService.cancelPendingRequest(cancelable);
        };

        this.getUri = function (str, data) {
            str = str || '';
            data = data || {};

            if (Object.keys(data).length) {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        str = str.replace(':' + key, data[key]);
                    }
                }
            }

            return this.baseUri.replace(':contract_id', this.contract_id) + str;
        };

        this._setUrlParams = function (url, searchParams) {
            if ($window.URLSearchParams && angular.isDefined(searchParams) && Object.keys(searchParams).length) {
                var urlParams = new $window.URLSearchParams($window.location.search);

                for (var key in searchParams) {
                    if (searchParams.hasOwnProperty(key) && searchParams[key] !== null) {
                        if (!urlParams.has(key)) {
                            urlParams.append(key, searchParams[key])
                        }
                    }
                }

                if (urlParams.toString().length) {
                    url += '?' + urlParams.toString();
                }
            }

            return url;
        };

    }]);
